import React from 'react';
import { Button } from '../Button/Button';
import './ConfirmationModal.scss';

interface ConfirmationModalProps {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  variant?: 'danger' | 'warning' | 'info';
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  title,
  message,
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
  variant = 'danger',
}) => {
  return (
    <div className={`confirmation-modal ${variant}`}>
      <h2>{title}</h2>
      <p>{message}</p>
      <div className="actions">
        <Button variant="button" className="outline cancel" type="button" onClick={onCancel}>
          {cancelLabel}
        </Button>
        <Button variant="button" type="submit" onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </div>
    </div>
  );
};
